import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, HostListener } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Validators, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputValidationService } from '../helpers/validators/input-validation.service';
import { RegExValidation } from '../helpers/constants/regex-validation.constants';
import { NgbAccordionModule, NgbModal, NgbModalOptions, NgbModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { OtpService } from '../services/otp.service';
import { Router, RouterLink } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from '../../environments/environment';
import { CommonModule, CurrencyPipe, PlatformLocation } from '@angular/common';
import { Guid } from 'guid-typescript';
import { Enum } from '../helpers/enums/enum';
import { UserAuthService } from '../services/user-auth.service';
import { CampaignService } from '../services/campaign.service';
import { Subscription, interval, timer } from 'rxjs';
import { VcclogoComponent } from '../shared/vcclogo.component';
import { TrackingDirective } from '../helpers/directive/tracking.directive';
import { FormatimePipe } from '../helpers/pipe/formatime.pipe';
import { PasswordStrengthBar } from '../helpers/components/password-strength-bar';
import { FooterComponent } from '../shared/footer.component';
import { HeaderComponent } from '../shared/header.component';
import { CommunicationService } from '../services/communication.service';
import { DEFAULT_MODAL_OPTIONS } from '../shared/constants/app.constants';
import { LogoComponent } from '../logo/logo.component';

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  host: {'class': 'd-flex flex-column h-100 ipadfooterbottom'},
  styleUrls: ['./forgot.component.css'],
  standalone: true,
  imports: [
      TrackingDirective,
      NgbPopoverModule,
      NgbAccordionModule,
      RouterLink,
      VcclogoComponent,
      CurrencyPipe,
      CommonModule,
      NgbModule,
      FormsModule,
      FormatimePipe,
      ReactiveFormsModule,
      PasswordStrengthBar,
      FooterComponent,
      HeaderComponent,LogoComponent
  ],
})
export class ForgotComponent implements OnInit {
  private get otpWindowMs(): number {
    return environment.otpPolicy.sessionLifespanMinutes * 60 * 1000;
  }

  private get resendUnlockThreshold(): number {
    return environment.otpPolicy.firstOtpExpiryMinutes * 60 - environment.otpPolicy.resendAfterSeconds;
  }

  modalOptions: NgbModalOptions;
  userData = null;
  otpForm; password;
  visible:boolean=true;
  changetype:boolean=true;
  visiblec:boolean=true;
  changetypec:boolean=true;
  errorMsg = '';
  otpErrorMsg = '';
  sendOtpText = 'Send OTP';
  requestOTPBtnDisplay = 'Send OTP';
  successMsg = '';
  usedOtpType;
  panelText = 'To reset your password, enter the cellphone number or email address that is linked to your profile and request an OTP';
  IsSuccess : boolean = false;
  displaySection = 'SendOTPRequest'
  showDiv : boolean = false;
  campaignCookieName: string='user_campaign';
  utm_id: string;
  isSecondTimeLogin:boolean=false;

  disableOTPSendButton: boolean = false;
  secondsLeft;
  countDown: number = 30;
  otpSentSuccessfully: boolean = false;
  sendOtpTextButton: string = 'Send OTP';
  hideResendOTPButton: boolean = false;
  optSessionStillValid: boolean = false;
  otpSentSuccesfully: number;
  numbersubs: Subscription;
  sessionTimeOut: Subscription;
  numbersubs2: Subscription;
  isNumberSub2Subscribed: boolean = false;
  isNumberSubSubscribed: boolean = false;
  isSessionTimeOutSubscribed: boolean = false;
  otpSessionTimeOutInterval;
  otpSession10MinInterval;
  secLeftResendAllowed: number;
  counter : number;
  tick = 1000;
  successMsgWithPipe: boolean = false;
  passwordUpdatedSuccessfully: boolean = false;
  callbackErrorMsg = '';
  callbackSuccessMsg = '';
  hasForgotPasswordError = false;
  forgotPasswordOtpWrongMsg = '';

  constructor(
    private readonly otpService: OtpService,
    private readonly formBuilder: FormBuilder,
    public readonly router: Router,
    private readonly location: PlatformLocation,
    private readonly modalService: NgbModal,
    private readonly cookieService: CookieService,
    private readonly oauthService: OAuthService,
    private readonly userAuthService: UserAuthService,
    private readonly campaignService: CampaignService,
    private readonly communicationService: CommunicationService,
  ) {
    this.modalOptions = DEFAULT_MODAL_OPTIONS;
    location.onPopState(() => this.modalService.dismissAll());
  }




  ngOnInit() {

    let isSecondLoginByBranchUser = sessionStorage.getItem("branchUserLogin");
    console.log("Branch User Is Second Login", isSecondLoginByBranchUser);
    if (isSecondLoginByBranchUser == Enum.BranchUserLoginType.SecondLogin.toString())
    {
      this.isSecondTimeLogin = true;
    }
    
    localStorage.removeItem('tempToken');
    this.displaySection ='SendOTPRequest',
    this.otpForm = this.formBuilder.group({
      SearchText: ['', [Validators.required]],
      Otp: ['', [Validators.required, Validators.minLength(6)]],
      Password: ['', [Validators.required, Validators.minLength(8), Validators.pattern(RegExValidation.password)]],
      ConfirmPassword: ['', Validators.required]
    }, {
      validator: [
        InputValidationService.passwordMustMatch('Password', 'ConfirmPassword'),
      ],
    });
    this.userAuthService.logoutActiveUser(globalThis.location.origin + '/forgot');
  }



  get otpFormControls() { return this.otpForm.controls; }

  sendOtp() {

    this.successMsg = '';
    this.otpErrorMsg = '';
    const searchText = 'SearchText';
    if (this.otpForm.controls[searchText].value === '') {
      this.otpForm.controls[searchText].markAllAsTouched();
      return;
    }

    const param = { SearchText: this.otpForm.value.SearchText };
    
    if (!RegExValidation.cellNumber.test(param.SearchText) &&
      !RegExValidation.email.test(param.SearchText)) {
      this.otpErrorMsg = 'Please enter valid input.';
      return;
    }

    this.usedOtpType = RegExValidation.cellNumber.test(param.SearchText) ? Enum.OtpType.Sms : Enum.OtpType.Email;

      this.otpService.forgotPasswordSendOtp(param).subscribe({
        next: (data: any) => {

           this.hasForgotPasswordError = true
           this.forgotPasswordOtpWrongMsg = 'An OTP has been sent to your registered mobile number.If you haven’t received it, please verify your number or complete your registration.To go back, '
          
          if (data.status === 200) {
            this.displaySection = 'UpdatePasswordSection';
            this.otpSentSuccessfully = true;
            this.panelText = 'Enter your OTP and create a new password';
            setTimeout(()=>this.getOtpFromSms(),2000);
            if (data?.sendOtpStatusType?.message === "SecondOTPSent")
            {
               this.hideResendOTPButton = true;
            }
            if(this.sendOtpText === 'Send OTP')
            {
              this.otpSession10MinInterval = setTimeout(() => {
                setTimeout(() => {
                  globalThis.location.reload();
                }, 8000);
                this.otpErrorMsg = 'OTP session has expired, please try again.'
              }, this.otpWindowMs);

              if(this.isNumberSubSubscribed)
              {
                this.secondsLeft = 0;
                this.numbersubs.unsubscribe();
              }
              this.disableOTPSendButton = true;
  
              let numbers = interval(1000);
              this.numbersubs = numbers.subscribe(x => {
                this.isNumberSubSubscribed = true;
                this.secondsLeft = this.countDown - x;
                if (this.secondsLeft == 0) {
                  this.numbersubs.unsubscribe();
                  this.isNumberSubSubscribed = false;
                  this.disableOTPSendButton = false;
                }
              });
            }
  
            this.otpSentSuccessfully = true;
            localStorage.setItem('tempToken', data.token);
  
            if (this.sendOtpText === 'Resend OTP') {
              this.successMsg = 'Resend OTP sent successfully';
              this.disableOTPSendButton = true;
              this.hideResendOTPButton = true;
            }
            this.sendOtpText = 'Resend OTP';
            this.requestOTPBtnDisplay = 'Resend OTP';
          }
  
          if(data.sendOtpStatusType.status === 202)
          {
            this.otpErrorMsg = 'OTP already verified, please try later.';
          }
        },
        error: (err: HttpErrorResponse) => {
          if (err.status === 501) {
            this.otpErrorMsg = 'We can not find your contact details. If you have not already registered please go to the registration page, alternatively call one of our coaches for assistance.';
          }

          if(err.error.sendOtpStatusType.status===421){
            if(err.error.sendOtpStatusType.sessionTimeOut > 0){
              localStorage.setItem('tempToken', err.error.token);
              this.requestOTPBtnDisplay = "Resend OTP";
              this.displaySection = 'UpdatePasswordSection';
              this.panelText = 'Enter your OTP and create a new password'
              this.sendOtpText = "Resend OTP";
              this.secLeftResendAllowed = err.error.sendOtpStatusType.sessionTimeOut - this.resendUnlockThreshold;

              if(this.secLeftResendAllowed > 0){
                this.hideResendOTPButton = false;
                this.disableOTPSendButton = true;
                let numbers2 = interval(1000);
                this.numbersubs2 = numbers2.subscribe(x => {
                  this.isNumberSub2Subscribed = true;
                  this.secondsLeft = this.secLeftResendAllowed - x;
                  if (this.secondsLeft == 0) {
                    this.numbersubs2.unsubscribe();
                    this.isNumberSub2Subscribed = false;
                    this.disableOTPSendButton = false;
                  }
                });
                this.successMsgWithPipe = false;

              }else{
                this.hideResendOTPButton = true;
                this.otpSessionTimeOutInterval =     setTimeout(() => {
                  this.counter = err.error.sendOtpStatusType.sessionTimeOut;
                  this.sessionTimeOut = timer(0, this.tick).
                  subscribe(() => {
                    this.isSessionTimeOutSubscribed = true;
                    --this.counter;
                    this.successMsgWithPipe = true;
                    if(this.counter === 0){
                      this.sessionTimeOut.unsubscribe();
                      globalThis.location.reload();
                    }
                  });


                  this.successMsg = '';

                }, 2000);
              }

              this.optSessionStillValid = true;
              this.otpSentSuccessfully = true;
            }
            else{
              this.otpErrorMsg = "OTP Already Sent. Please try after later";
             }
          } else{
            this.otpErrorMsg = 'Please contact admin';
          }
        }
      });
  }


  resetOtpToDefault(){
    if(this.otpSession10MinInterval != undefined){
      clearTimeout(this.otpSession10MinInterval);
      this.otpSession10MinInterval = undefined;
    }
    if(this.otpSessionTimeOutInterval != undefined){
      clearTimeout(this.otpSessionTimeOutInterval);
    }
    if(this.isSessionTimeOutSubscribed){
      this.successMsgWithPipe = false;
      this.sessionTimeOut.unsubscribe();
    }

    if(this.isNumberSubSubscribed)
    {
      this.numbersubs.unsubscribe();
    }

    if(this.isNumberSub2Subscribed)
      {
        this.numbersubs2.unsubscribe();
      }
    this.successMsgWithPipe = false;
    this.optSessionStillValid = null;
    this.otpSentSuccessfully = false;
    this.panelText = '';
  }


  forgot() {
    this.otpErrorMsg = '';
    this.successMsg = '';

    console.log("OTP FORM" , this.otpForm.invalid);
    console.log("OTP FORM" , this.otpForm);
    if (this.otpForm.invalid) {
      this.otpForm.markAllAsTouched();
      return;
    }

    const param = {
      Password: this.otpForm.value.Password,
      Otp: parseInt(this.otpForm.value.Otp, 10),
      OtpType: this.usedOtpType
    };


      this.otpService.forgotPasswordUpdate(param).subscribe((data: any) => {

        this.cookieService.delete('OTPSendStatus');
        this.cookieService.delete('OTPSentSuccessfully');
        this.displaySection = 'OTPSuccessfullyChangedSection';
        this.otpForm.reset();
        this.otpForm.disable();
        this.sendOtpText = 'Send OTP';
        this.resetOtpToDefault();
        this.passwordUpdatedSuccessfully = true;
        this.IsSuccess = true;
        sessionStorage.removeItem('branchUserLogin');
      },
        (err: HttpErrorResponse) => {

          if (err.status === 422) {
            this.otpErrorMsg = 'Incorrect OTP';
            setTimeout(() => {
              this.otpErrorMsg = '';
            }, 3000);
          }
          else if(err.status === 403){
            this.otpErrorMsg = "OTP session has expired, please try later.";
            this.resetOtpToDefault();
             setTimeout(() => {
               globalThis.location.reload();
             }, 5000);


          }else{
            this.otpErrorMsg = 'Please contact admin';
          }
        });
  }
  viewpass(){
    this.visible=!this.visible;
    this.changetype=!this.changetype;
  }
  viewpassofConfirm(){
    this.visiblec=!this.visiblec;
    this.changetypec=!this.changetypec;
  }

  azureAdlogin() {
    localStorage.removeItem('tempToken');
    let submissionId = '';
    if (this.cookieService.get('submissionId')) {
      submissionId = this.cookieService.get('submissionId');
    }
    const submissionCode = Guid.create().toString();
    let branchUsePWDCheck =  sessionStorage.getItem('IsBranchPwdUpdated');
    let branchUser =  sessionStorage.getItem('IsAssociatedWithBranch');
    let campaignCookie = this.cookieService.get(this.campaignCookieName);
    if (campaignCookie && campaignCookie !== '')
    {
      //get utm_id from campaign cookie
      this.campaignService.getActiveCampaign('', campaignCookie).subscribe((data: any) => {
        console.log('active campaign data', data);
        if (data && data.campaignUtmId) {
          this.utm_id = data.campaignUtmId;
        }
        this.oauthService.initLoginFlow('', {
          submissionId, ccAppUrl: globalThis.location.origin, submissionCode,
          instrumentationKey: environment.appInsights.instrumentationKey,
          utm_id: this.utm_id
        });
      }, (error: HttpErrorResponse) => console.log(error));

    }
     if(branchUsePWDCheck!=null || branchUsePWDCheck== 'false' ||branchUser!=null)
    {
        this.oauthService.initLoginFlow('', {
          submissionId, ccAppUrl: globalThis.location.origin, submissionCode,
          instrumentationKey: environment.appInsights.instrumentationKey,
          utm_source:'branches',
          login_Count:1
        });

      }
    else {
      this.oauthService.initLoginFlow('', {
        submissionId, ccAppUrl: globalThis.location.origin, submissionCode,
        instrumentationKey: environment.appInsights.instrumentationKey
      });
    }

  }

  handleKeyDown(event: any) {
    if (event.keyCode === 13) {
       this.sendOtp();
       this.otpForm.markAsUntouched();
       }
  }

  azureActivelogin() {
    let submissionId = '';
    if (this.cookieService.get('submissionId')) {
      submissionId = this.cookieService.get('submissionId');
    }
    const submissionCode = Guid.create().toString();
    this.oauthService.initLoginFlow('', { submissionId, ccAppUrl: globalThis.location.origin, submissionCode,
      instrumentationKey: environment.appInsights.instrumentationKey });
  }
  getOtpFromSms(){
    if ('OTPCredential' in window) {
      const ac = new AbortController();


      setTimeout(() => {
        // abort after two minutes
        ac.abort();
      }, 2 * 60 * 1000);
      let o={
        otp: { transport:['sms'] },
        signal: ac.signal
      };

      navigator.credentials.get(o).then((otp:any) => {
      const input:any=document.getElementById("otpAutoFill");
      const label:any=document.getElementById("otpAutoFillLabel");
      console.log("otp from SMS ",otp.code);
      label.innerText="";
      input.value=otp.code;
      this.otpForm.controls["Otp"].markAsUntouched();
      this.otpForm.controls["Otp"].markAsPristine();



      }).catch(err => {
      console.log("Error in reading OTP from SMS ",err)
      });

      } else {
      console.log('WebOTP not supported!.')
      }
  }  
  speakToCoachCallback() {     
    const searchText = 'SearchText';    
    this.callbackErrorMsg = '';
    this.callbackSuccessMsg = '';   
    const searchControl = this.otpForm.controls[searchText];
    this.otpErrorMsg='';
    if (searchControl.value === '') {
      searchControl.markAllAsTouched();
      return;
    }
    const searchParam = { SearchText: this.otpForm.value.SearchText };
    if (!RegExValidation.cellNumber.test(searchParam.SearchText) &&
      !RegExValidation.email.test(searchParam.SearchText)) {
      this.otpErrorMsg = 'Please enter valid input.';
      return;
    } 
    const param = { campaignSourceType: Enum.LmsCampaignSourceType.PasswordReset , SearchText: searchParam.SearchText };  
    this.communicationService.requestCoachAssistanceForPassword(param).subscribe({
      next: (data: any) => {
        this.callbackSuccessMsg = 'A coach will call you shortly to assist.';      
        setTimeout(() => { globalThis.location.reload(); },  3000);
      },
      error: (err: HttpErrorResponse) => {
        if (err.status === 400) {
          this.callbackSuccessMsg = 'A coach will call you shortly to assist.';
          setTimeout(() => { globalThis.location.reload(); },  3000);
        }       
        else if (err.status === 501) {
            this.otpErrorMsg = 'We can not find your contact details. If you have not already registered please go to the registration page, alternatively call one of our coaches for assistance.';
          }
        else {       
         this.callbackErrorMsg = 'Error: Please try after some time';
        }
      }
    });
  }

  // Method to show Send OTP section and reset OTP related variables to default values
  showSendOTPSection() {
    this.resetOtpToDefault();
    setTimeout(() => {
      globalThis.location.reload();
    }, 1000);
  }
 }
